// Collects billing address for FramePay createToken extraData.
//
// Nuvei requires country and email on the instrument at tokenize
// time. Form fields tagged data-rebilly are the source; a checked
// address radio (data-rebilly-country) overrides street fields so
// a selection change is what gets tokenized.

const MISSING_COUNTRY =
  "A billing country is required to save this card."
const MISSING_EMAIL =
  "An email address is required to save this card."

const CONTACT_ARRAY_FIELDS = new Set(["emails", "phoneNumbers"])
const SKIP_REBILLY_KEYS = new Set(["token", "payment-instrument"])
const RADIO_ADDRESS_KEYS = [
  ["rebillyOrganization", "organization"],
  ["rebillyAddress", "address"],
  ["rebillyAddress2", "address2"],
  ["rebillyCity", "city"],
  ["rebillyRegion", "region"],
  ["rebillyCountry", "country"],
  ["rebillyPostalCode", "postalCode"]
]

function collectBillingAddress(form) {
  const billingAddress = {}
  assignRebillyFields(form, billingAddress)
  assignSelectedRadio(form, billingAddress)
  return compact(billingAddress)
}

function assertRequiredBillingAddress(billingAddress) {
  if (!present(billingAddress.country)) {
    throw new Error(MISSING_COUNTRY)
  }
  if (!present(emailValue(billingAddress))) {
    throw new Error(MISSING_EMAIL)
  }
}

function assignRebillyFields(form, billingAddress) {
  const fields = form.querySelectorAll("[data-rebilly]")
  for (let i = 0; i < fields.length; i++) {
    const el = fields[i]
    if (!isCollectable(el)) continue

    const key = el.getAttribute("data-rebilly")
    if (!key || SKIP_REBILLY_KEYS.has(key)) continue

    const value = (el.value || "").trim()
    if (!present(value)) continue

    if (CONTACT_ARRAY_FIELDS.has(key)) {
      billingAddress[key] = [{ label: "main", value: value }]
    } else {
      billingAddress[key] = value
    }
  }
}

function assignSelectedRadio(form, billingAddress) {
  const radio = form.querySelector(
    'input[type="radio"][data-rebilly-country]:checked'
  )
  if (!radio) return

  for (let i = 0; i < RADIO_ADDRESS_KEYS.length; i++) {
    const datasetKey = RADIO_ADDRESS_KEYS[i][0]
    const field = RADIO_ADDRESS_KEYS[i][1]
    const value = present(radio.dataset[datasetKey])
      ? String(radio.dataset[datasetKey]).trim()
      : ""
    if (present(value)) {
      billingAddress[field] = value
    } else {
      delete billingAddress[field]
    }
  }
}

function isCollectable(el) {
  if (el.disabled) return false
  if (el.closest && el.closest(".hidden")) return false
  return true
}

function compact(billingAddress) {
  const out = {}
  Object.keys(billingAddress).forEach((key) => {
    const value = billingAddress[key]
    if (CONTACT_ARRAY_FIELDS.has(key)) {
      const first = Array.isArray(value)
        ? (value[0] && value[0].value)
        : value
      if (present(first)) out[key] = value
      return
    }
    if (present(value)) out[key] = value
  })
  return out
}

function emailValue(billingAddress) {
  const emails = billingAddress.emails
  if (Array.isArray(emails)) {
    return (emails[0] && emails[0].value) || ""
  }
  return emails || ""
}

function present(value) {
  return value != null && String(value).trim() !== ""
}

exports.MISSING_COUNTRY = MISSING_COUNTRY
exports.MISSING_EMAIL = MISSING_EMAIL
exports.collectBillingAddress = collectBillingAddress
exports.assertRequiredBillingAddress = assertRequiredBillingAddress
